import ReactApexChart from "react-apexcharts";

export const ChartBar = ({ data, labels }) => {
  const state = {
    series: [{
      name: 'Cantidad de registros',
      data: data
    }],
    options: {
      annotations: {
        points: [{
          x: 'Bananas',
          seriesIndex: 0,
          label: {
            borderColor: '#775DD0',
            offsetY: 0,
            style: {
              color: '#fff',
              background: '#775DD0',
            },
            text: 'Bananas are good',
          }
        }]
      },
      chart: {
        height: 400,
        type: 'bar',
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          columnWidth: '50%',
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val;
        },
        offsetY: -20,
        style: {
          fontSize: '30px',
          colors: ["#304758"]
        }
      },
      stroke: {
        width: 0
      },
      grid: {
        row: {
          colors: ['#fff', '#f2f2f2']
        }
      },
      xaxis: {
        labels: {
          rotate: -45
        },
        categories: labels,
        tickPlacement: 'on',
      },
      yaxis: {
        title: {
          text: 'Cantidad de pacientes'
        },
        labels: {
          style: {
            fontSize: '18px', // Aumenta el tamaño de los números en el eje Y
            fontWeight: 600, // Hace los números más gruesos
            color: "#000", // Mejora la legibilidad
          }
        }
      },
      fill: {
        colors: ['#BC955B']
      }
    },
  };

  return (
    <div style={{ width: "100%" }}>
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="bar"
        height={400}
        width="100%"
      />
    </div>
  );
}
